//@flow

import { OPEN_MODAL, CLOSE_MODAL } from './types';
import type { Action } from '../../types/action';

export const openModal = (): Action => ({
  type: OPEN_MODAL,
});

export const closeModal = (): Action => ({
  type: CLOSE_MODAL,
});



// WEBPACK FOOTER //
// ./src/redux/actions/modalAction.js